module.exports = __webpack_public_path__ + "static/img/icon_clear_white.dd8598d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_clear_white.png
// module id = xnVB
// module chunks = 1